import { useEffect } from "react";
import { ChatInstructionResult } from "./useEditorAI";

export const useChatIntegration = (
  chat: any,
  user: any,
  mdRef: React.MutableRefObject<string>,
  setInstructionHandler: (handler: (prompt: string) => Promise<any>) => void,
  chatInstruction: (prompt: string, contexto: string, instruccion: string) => Promise<ChatInstructionResult>,
  applyNewDoc: (doc: string) => void
) => {
  useEffect(() => {
    if (!chat) return;
    const handler = async (chatPrompt: string) => {
      const { responseText, changeDoc } = await chatInstruction(chatPrompt, mdRef.current, "Editar");
      if (changeDoc) applyNewDoc(changeDoc);
      return { assistantText: responseText ?? "", contextSnapshot: changeDoc ?? "" };
    };
    setInstructionHandler(handler);
  }, [setInstructionHandler, user, chat, chatInstruction, applyNewDoc]);
};